/**
* Include your custom JavaScript here.
*
* We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
* changes on product page, you can attach a listener to the document:
*
* document.addEventListener('variant:changed', function(event) {
*   var variant = event.detail.variant; // Gives you access to the whole variant details
* });
*
* You can also add a listener whenever a product is added to the cart:
*
* document.addEventListener('product:added', function(event) {
*   var variant = event.detail.variant; // Get the variant that was added
*   var quantity = event.detail.quantity; // Get the quantity that was added
* });
*/


/* Used for AU / NZ Site redirection — dev early 2025 but not launched
if (!Shopify.designMode && enable_redirect) {
	if (region_param) {
		//If we've been redirected with a region parameter in url
		setCookie('geo_location', region_param, 365);
		region = region_param;
	}

	if (region) {
		//console.log( current_region+' / '+region)
		storeSelection(region)
	} else {
		//No region cookie or param so get location from IPRegistry
		var request = new XMLHttpRequest();
		request.onreadystatechange = function() {
			if (request.readyState === 4 && request.status === 200) {
				json = JSON.parse(request.responseText)

				const us_countries = 'CA US'
				const nz_countries = 'NZ'

				if (nz_countries.indexOf(current_code) >= 0) {
					region = 'nz';
				} else {
					region = 'au';
				}

				storeSelection(region);
			}
		};
		request.open('GET', 'https://api.ipregistry.co/?key=ira_p516tepyp5k6ER2xRmZa2fRO9CrwT02GP0fl', true);
		request.send(null);
	}
}*/

(function() {
	    var touchingCarousel = false,
	      touchStartCoords;

	    document.body.addEventListener('touchstart', function(e) {
		      if (e.target.closest('.flickity-slider')) {
			        touchingCarousel = true;
		      } else {
			        touchingCarousel = false;
			        return;
		      }

		      touchStartCoords = {
			        x: e.touches[0].pageX,
			        y: e.touches[0].pageY
		      }
	    });

	    document.body.addEventListener('touchmove', function(e) {
		      if (!(touchingCarousel && e.cancelable)) {
			        return;
		      }

		      var moveVector = {
			        x: e.touches[0].pageX - touchStartCoords.x,
			        y: e.touches[0].pageY - touchStartCoords.y
		      };

		      if (Math.abs(moveVector.x) > 7)
			        e.preventDefault()

	    }, {passive: false});
  })();

function loadJSONProductColourSwatches(data) {
	$.ajax({
		url:	"/collections/all?view=json",
		type:	'GET'
	})
	.done(function(data) {
		//console.log($.parseJSON(data));

		$.each(JSON.parse(data).results, function(index, item) {
			// product_key and product_colour come from 'js-variables.liquid'
			//console.log(product_key+'//'+item.key);

			item_title = item.title


			if (typeof item_title !== 'undefined' && item_title.indexOf("Chino Shorts") >= 0) {
				console.log(item_title);
			}

			if (typeof product_key !== 'undefined' && product_key == item.key) {

				//console.log(product_key+'//'+item.key + item.colour);

				var current_product = ""
				if( item.colour == product_colour) {
					current_product = " is-active"
				}

				const colour_handle = item.colour.toLowerCase().replace(/\s+/g, '-');

				$('.ProductForm__Variants .ProductItem__ColorSwatchList').append(
					'<a href="'+item.url+'" ' +
						'data-color="'+item.colour+'" ' +
						'class="ColorSwatch '+colour_handle+' '+current_product+'" ' +
						'style="background-color:'+item.colour+'; background-image:url('+item.swatch+');"></a>'
				);
			}
		});
	})
	.fail(function(data) {})
	.always(function(data) {});
}


function loadJSONcollectionSwatches(data) {
	console.log('run script');

	$.ajax({
		url:	"/collections/"+collection_url+"?view=json",
		type:	'GET'
	})
	.done(function(data) {


		//console.log('test url: /collections/'+collection_url+'?view=json');
		console.log($.parseJSON(data));

		$.each(JSON.parse(data).results, function(index, item) {

			//console.log('compare key: '+item.key+' color: '+item.colour);


			//Find matching products and add swatches
			$('.ProductItem').each(function( index ) {
				var collection_product_key = $(this).find('.ProductItem__Title').text().trim();
				var collection_product_colour = $(this).find('.ProductItem__Colour').text().trim().replace('/','-').toLowerCase();

				//console.log('key: '+collection_product_key+' color: '+collection_product_colour);

				//console.log(item.colour+' // '+collection_product_colour);

				var current_product = ""
				if( item.colour == collection_product_colour ) {
					current_product = " is-active"
				}

				if (collection_product_key == item.key) {

					price = item.price
					price = '$'+price/100

					compare_at_price = item.compare_at_price
					compare_at_price = '$'+compare_at_price/100

					item_variants = '';
					$.each(item.variants, function(i, v) {
						//console.log(v)
						item_variants = item_variants + 'data-var_'+v.id+'="'+v.option1+':'+v.inventory_quantity+'" '
					});

					$(this).find('.ProductItem__ColorSwatchList').append('<a data-image="'+item.firstImage+'" data-image2="'+item.secondImage+'" '+item_variants+'data-url="'+item.url+'" data-colour="'+item.colour+'" class="ColorSwatch ColorSwatch--small '+item.colour+current_product+'" style="background-color:'+item.colour+'; background-image:url('+item.swatch+')" data-price="'+price+'" data-compare="'+compare_at_price+'"></a>');
				}
			});
		});


		$(swatchSlider);


	})
	.fail(function(data){})
	.always(function(data){});
}

if ($('body.template-collection').length > 0) {
	$(loadJSONcollectionSwatches);
}


function selected_variant(swatch) {
	swatch.parent().find("a").removeClass("is-active");
	swatch.addClass("is-active");

	const product_item = swatch.closest('.ProductItem');
	let = new_variants = ''
	$.each(swatch.data(), function(i, v) {
		//console.log(i)

		if ( i.indexOf("var_") !== -1 ) {
			const
				v_id = i.replace('var_',''),
				v_data = v.split(':');
			let v_avail = ' class="unavailable" ';

			console.log( parseInt(v_data[1]) )

			if ( parseInt(v_data[1]) > 0 ){
				v_avail = ''
			}
			new_variants = new_variants + '<li><button type="button"'+v_avail+' value="'+v_id+'">'+v_data[0]+'</button></li>'
			//console.log(v)
		}
	});
	product_item.find(".product-size-list ul").html(new_variants);

	if(swatch.data("image")){
		var img_1 = product_item.find(".ProductItem__Image:eq(1)");
		var img_2 = product_item.find(".ProductItem__Image:eq(0)");
		img_1.attr("srcset", swatch.data("image"));
		img_2.attr("srcset", swatch.data("image2"));
	}

	product_item.find(".ProductItem__ImageWrapper, .ProductItem__Title a").attr('href', swatch.data("url"));
	product_item.find(".ProductItem__Colour").html(swatch.data('colour'));

	product_item.find(".FullPrice").html(swatch.data('price'));
	product_item.find(".Price--compareAt").html(swatch.data('compare'));

	if ( swatch.data('price') > swatch.data('compare') ) {
		product_item.find(".Price--compareAt").hide();
		product_item.find(".FullPrice").removeClass('Price--highlight');
	} else {
		product_item.find(".Price--compareAt").show();
		product_item.find(".FullPrice").addClass('Price--highlight');
	}

}


$('.ProductItem').on('click', '.ColorSwatch', function() {
	selected_variant($(this));
});

//Triggered from _rerenderCart in theme.js
const
	collection_promo_1 = document.getElementById('collection-promo-1'),
	collection_promo_2 = document.getElementById('collection-promo-2');

function update_collection_promos(){
	if (window.location.href.indexOf("/collections/") > -1) {
		fetch(window.location.href+'/?sections=collection-template')
		.then(response => response.text())
		.then(html => {
			//console.log( JSON.parse(html) )
			parsedHTML = JSON.parse(html)
			//console.log(parsedHTML)
			var page_html = 'collection-template'
			const parsedPage = parsedHTML[page_html]

			var parser = new DOMParser();
			var pageHTML = parser.parseFromString(parsedPage, 'text/html');

			const
				collection_promo_1_new = pageHTML.getElementById('collection-promo-1').innerHTML,
				collection_promo_2_new = pageHTML.getElementById('collection-promo-2').innerHTML;

			collection_promo_1.innerHTML = collection_promo_1_new;
			collection_promo_2.innerHTML = collection_promo_2_new;

		})
		.catch(e => {
			console.error(e);
		});
	}
}

function update_cart_gwp(){

	const cart_form = document.querySelector('form.Drawer__Content');
	if (!cart_form) return;

	const
	progress_header = cart_form.querySelector('.goal-progress-header'),
	progress_bar = cart_form.querySelector('.bar'),
	progress_1 = cart_form.querySelector('.goal-1'),
	progress_2 = cart_form.querySelector('.goal-2'),
	progress_3 = cart_form.querySelector('.goal-3');

	if ( progress_header ) {
		const
		gift_type_1 = progress_header.getAttribute('gift_type_1'),
		gift_1_title = progress_header.getAttribute('gift_1_title'),
		gift_2_title = progress_header.getAttribute('gift_2_title'),
		gift_3_title = progress_header.getAttribute('gift_3_title');
		only_highest_tier = progress_header.getAttribute('only_highest_tier');

		let
		cart_price =  parseInt(progress_header.getAttribute('cart_price')),
		cart_total_price = parseInt(progress_header.getAttribute('cart_total_price')),
		threshold_in_cents_1 = parseInt(progress_header.getAttribute('threshold_in_cents_1')),
		threshold_in_cents_2 = parseInt(progress_header.getAttribute('threshold_in_cents_2')),
		threshold_in_cents_3 = parseInt(progress_header.getAttribute('threshold_in_cents_3')),
		triggered_goal_1 = false,
		triggered_goal_2 = false,
		triggered_goal_3 = false,
		next_goal = '',
		goal_prefix = 'a FREE ';

		const
		header_gwp_1 = document.querySelectorAll('.gwp_1'),
		header_gwp_2 = document.querySelectorAll('.gwp_2');
		header_gwp_3 = document.querySelectorAll('.gwp_3');

		let rate = 1

		let gift_1_class = "";

		if ( baseCurrency != 'AUD' ) {
			if ( gift_type_1 != 'shipping') {
				gift_1_class = "block";
				/* for markets
				threshold_in_cents_1 = threshold_in_cents_1 * exchange_rate; */
			}
			/* for markets
			threshold_in_cents_2 = threshold_in_cents_2 * exchange_rate;
			threshold_in_cents_3 = threshold_in_cents_3 * exchange_rate; */
		}

		const
		gwp_1_dff = (threshold_in_cents_1 - cart_price) / 100.00,
		gwp_2_dff = (threshold_in_cents_2 - cart_price) / 100.00;
		gwp_3_dff = (threshold_in_cents_3 - cart_price) / 100.00;

		let
		header_gwp_1_msg =  `You are <b>$<span data-money-convertible>${ gwp_1_dff.toFixed(2) }</span></b> away from <b class="${gift_1_class}">${gift_1_title.split(' - ')[0]}</b>`,
		header_gwp_2_msg =  `You are <b>$<span data-money-convertible>${ gwp_2_dff.toFixed(2) }</span></b> away from a <b class="block">FREE ${gift_2_title.split(' - ')[0]}</b>`;
		header_gwp_3_msg =  `You are <b>$<span data-money-convertible>${ gwp_3_dff.toFixed(2) }</span></b> away from a <b class="block">FREE ${gift_3_title.split(' - ')[0]}</b>`;

		if ( cart_price >= threshold_in_cents_1 && threshold_in_cents_1 != 0 ) {
			triggered_goal_1 = true;
			header_gwp_1_msg =  `You are eligible for<br/> <b>${gift_1_title.split(' - ')[0]}</b>`;
		}
		if ( cart_price >= threshold_in_cents_2 && threshold_in_cents_2 != 0 ) {
			triggered_goal_2 = true;
			header_gwp_2_msg =  `You are eligible for a FREE<br/> <b>${gift_2_title.split(' - ')[0]}</b>`;
		}
		if ( cart_price >= threshold_in_cents_3 && threshold_in_cents_3 != 0 ) {
			triggered_goal_3 = true;
			header_gwp_3_msg =  `You are eligible for a FREE<br/> <b>${gift_3_title.split(' - ')[0]}</b>`;
		}


		//Goal progress message2
		if (triggered_goal_2) {
			next_goal = gift_3_title;
			next_threshold = threshold_in_cents_3;
		} else if (triggered_goal_1) {
			next_goal = gift_2_title;
			next_threshold = threshold_in_cents_2;
		} else {
			if (gift_type_1 === 'shipping') {
				goal_prefix = '';
				next_goal = 'Free Shipping';
			} else {
				next_goal = gift_1_title;
			}
			next_threshold = threshold_in_cents_1;
		}

		//console.log( cart_price )
		//console.log( next_threshold+' / '+exchange_rate)
		//next_threshold = next_threshold * exchange_rate;
		//console.log( next_threshold)

		const paragraph = document.createElement('p');
		if (triggered_goal_3) {
			paragraph.innerHTML = 'Congrats, you have unlocked all free gifts!';
		} else if (next_goal === '' && gift_type_1 === 'shipping') {
			paragraph.innerHTML = 'Congrats, you have unlocked <b>FREE SHIPPING!</b>';
		} else if (next_goal !== '') {
			next_value = (next_threshold - cart_price) / 100.00;
			//console.log( next_value)
			paragraph.innerHTML = `You are <b>$<span data-money-convertible>${ next_value.toFixed(2) }</span></b> away from ${goal_prefix} <b>${next_goal.split(' - ')[0]}</b>`;
		}

		//console.log(progress_header)
		progress_header.innerHTML = paragraph.outerHTML;

		header_gwp_1.forEach(element => {
	  	element.innerHTML = header_gwp_1_msg;
		});
		header_gwp_2.forEach(element => {
	  	element.innerHTML = header_gwp_2_msg;
		});
		header_gwp_3.forEach(element => {
			element.innerHTML = header_gwp_3_msg;
		});

		//Goal progress bar
		let goal1D = threshold_in_cents_1 * 1.00;
		let goal2D = threshold_in_cents_2 * 1.00;
		let goal3D = threshold_in_cents_3 * 1.00;

		let maxGoal = goal1D;

		if (gift_3_title !== '') {
			maxGoal = goal3D;
		} else if (gift_2_title !== '') {
			maxGoal = goal2D;
		}

		let goalPercent = 10000.00 / maxGoal;
		let goalTotal = cart_price / 100;
		goalPercent *= goalTotal;

		let goal1Percent = goal1D / maxGoal;
		goal1Percent *= 100;
		let goal2Percent = goal2D / maxGoal;
		goal2Percent *= 100;

		if ( progress_bar ) {
			//Pretty sure this isn't used anymore - should be removed?
			progress_bar.style.width = `${goalPercent}%`;
			if ( progress_1 ) {
				progress_1.style.right = `${100 - goal1Percent}%`;
			}
			if ( progress_2 ) {
				progress_2.style.right = `${100 - goal2Percent}%`;
			}
		}

		//console.log('triggered_goal_3: '+triggered_goal_3);
		if ( triggered_goal_3 && only_highest_tier == 'true' ) {
			const gift_2_handle = progress_header.getAttribute('gift_2_handle');
			const gift_2_line = document.querySelector('[data-remove_handle="'+gift_2_handle+'"]')
			if (gift_2_line){
				gift_2_line.click();
			}
		}
	}
}

$('.product-size-list').on('click', 'button', function() {
	select_variant = $(this).val()

	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			quantity:1,
			id: select_variant
		},
		success: function(res){
			console.log("added: " + select_variant );
			document.documentElement.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: select_variant,
					quantity: 1
				}
			}));
			//update_collection_promos();
		},
		error: function(){
			// if it's not last one Move Along else update the cart number with the current quantity
			console.log('error')
		}
	});

});


function swatchSlider(data) {

	swatch_width = $('.ProductItem__SwatchContainer').width();

	$('.ProductItem__SwatchContainer').each(function() {
		inner_width = $(this).find('.ProductItem__ColorSwatchList').width();
		if(inner_width > swatch_width) {
			$(this).find('.swatch-right').show();
			$(this).attr('data-width', inner_width - swatch_width);

		}
	});
}

$('.swatch-right').click(function(){
	sc = $(this).closest('.ProductItem__SwatchContainer')
	s_position = sc.data('position')
	s_end = -Math.abs(sc.data('width'))

	s_position = s_position - swatch_width + 60

	sc.find('.ProductItem__ColorSwatchList').css('left', s_position+'px');
	sc.data('position', s_position);

	//console.log(s_position + ' // ' + s_end);

	if(s_position < s_end) {
		sc.find('.swatch-right').fadeOut();
	}
	sc.find('.swatch-left').fadeIn();
});

$('.swatch-left').click(function(){
	sc = $(this).closest('.ProductItem__SwatchContainer')
	s_position = sc.data('position')
	s_end = -Math.abs(sc.data('width'))

	s_position = s_position + swatch_width - 60

	sc.find('.ProductItem__ColorSwatchList').css('left', s_position+'px');
	sc.data('position', s_position);

	//console.log(s_position + ' // ' + s_end);


	if(s_position == 2) {
		sc.find('.swatch-left').fadeOut();
	}
	sc.find('.swatch-right').fadeIn();
});

$( document ).ready(function() {
	//Reorder collection size tags
	var $wrapper_desktop = $('.CollectionMain .Collapsible.size ul.Linklist');
	var $wrapper_mob = $('#collection-filter-drawer .Collapsible.size ul.Linklist');
	var order = ['xs', 's', 'm', 'l', 'xl', 'xxl', '6-10', '6-11', '28', '30', '31', '32', '33', '34', '35', '36', '37', '38'];

	$wrapper_desktop.find('.Linklist__Item').sort(function(a, b) {
		var aSize = $(a).data('value').toString(),
		bSize = $(b).data('value').toString();
		return order.indexOf(aSize) - order.indexOf(bSize);
	}).appendTo($wrapper_desktop);

	$wrapper_mob.find('.Linklist__Item').sort(function(a, b) {
		var aSize = $(a).data('value').toString(),
		bSize = $(b).data('value').toString();
		return order.indexOf(aSize) - order.indexOf(bSize);
	}).appendTo($wrapper_mob);



	//Reorder collection price tags
	var $wrapper_desktop = $('.CollectionMain .Collapsible.price ul.Linklist');
	var $wrapper_mob = $('#collection-filter-drawer .Collapsible.price ul.Linklist');
	var order = ['0-25', '25-50', '50-75', '75-100', '100-150', '150-200', '200-250', '250-300', '300-400'];

	$wrapper_desktop.find('.Linklist__Item').sort(function(a, b) {
		var aSize = $(a).data('value').toString(),
		bSize = $(b).data('value').toString();
		return order.indexOf(aSize) - order.indexOf(bSize);
	}).appendTo($wrapper_desktop);

	$wrapper_mob.find('.Linklist__Item').sort(function(a, b) {
		var aSize = $(a).data('value').toString(),
		bSize = $(b).data('value').toString();
		return order.indexOf(aSize) - order.indexOf(bSize);
	}).appendTo($wrapper_mob);
});


//Count number of pages
$('.flickity-page-dots').each(function() {
	var myParent = $(this).children('.dot');
	total_pages = 0;

	$(myParent).each(function() {
		total_pages = total_pages + 1;
	});

	$(this).closest('.Carousel').prevAll('.carousel-status').find('.total').html(total_pages);
});

/*Cousel click and potential touch - Prob not needed
$(document).on("click", ".Carousel", function(event) {
var theParent = $(this).find('.flickity-page-dots').children('.dot');

page_number = 1;

$(theParent).each(function() {
if ( $( this ).hasClass('is-selected') ) {
return false;
} else {
page_number = page_number + 1;
}
});

$(this).closest('.Carousel').prevAll('.carousel-status').find('.current').html(page_number);
});
*/

//Track Nav Clicks and Updated page number
$(document).ready(function() {

	//Move Next and Prev buttons to new location
	$(".flickity-prev-next-button.previous").each(function() {
		$(this).closest('.Carousel').prevAll('.carousel-status').find('.previous-slide').append(this);
	});

	$(".flickity-prev-next-button.next").each(function() {
		$(this).closest('.Carousel').prevAll('.carousel-status').find('.next-slide').append(this);
	});





	$('.ProductList--carousel').on("click", ".dot", function(event) {
		var theParent = $(this).parent('.flickity-page-dots').children('.dot').first();
		page_number = 1;
		if ( theParent.hasClass('is-selected') ) {
			return false;
		} else {
			page_number = page_number + 1;
		}

		$(this).closest('.ProductListWrapper').find('.current').html(page_number);
	});

});




$( document ).ready(function() {
	function setUp(){
		$(".collections-menu .parent-link").click(function(){
			if($(this).parent().find("ul").is(":visible"))
				$(this).removeClass("expanded");
			else
				$(this).addClass("expanded");
			$(this).parent().find("ul").slideToggle();
		});

		$('.collections-menu a.selected').closest('.top-level').find('a.parent-link').trigger('click').addClass('this');

		$(".toggle-filter-menu").click(function(e){
			e.preventDefault(); console.log("cjic");
			$('.collections-menu').toggleClass("expanded");
		});
	}

	setUp();
});

$('.close-AnnouncementBar').click(function(){
	$('#shopify-section-announcement').css('max-height','0px');
});


//Close drawer after 5 seconds when product added to cart
$('.ProductForm__AddToCart').click(function(){
	setTimeout(function() {
		$('#sidebar-cart .Drawer__Close').trigger('click');
	}, 5000);
});

$('#select-size-please .Button').click(function(){
	$('#select-size-please').fadeOut();
});


$(".Header__Logo").hover(function(){
	//$('.is-expanded').removeClass('is-expanded');

	//$('.Header__MainNav [aria-hidden="false"]').attr('aria-hidden', 'true');
});

$('.enquire-button').click(function(){
	$(this).hide();
	$('#contact_form').fadeIn();
});

function buildBundleItem(index, bundle_product, current_product, shop_data){

	//console.log(index)

	$.getJSON('/products/' + current_product.handle, function (product) {

		var product = product.product
		product_title = product.title

		$bundleObject = $("<div>", {"class": "bundle-object", "data-product": bundle_product, "data-index": index});

		$bundle_img = $("<div>", {"class": "bundle-img"});
		$bundle_info = $("<div>", {"class": "bundle-info"});
		$bundle_sizes = $("<div>", {"class": "SizeSwatchList HorizontalList"});
		$bundle_colours = $("<div>", {"class": "ProductItem__ColorSwatchList"});

		$bundle_img.append('<img src="'+current_product.firstImage+'"/>')
		$bundle_info.append('<h2>'+bundle_product+'</h2>')


		$bundle_info.append('<span class="ProductForm__Label">Size</span>')

		$.each(product.variants, function(i, variant) {

			console.log(index)

			var_title = variant.title
			var_title = var_title.split(' / ')[0]

			var_input = '<input class="SizeSwatch__Radio" type="radio" data-id="'+variant.id+'" id="swatch-'+variant.id+'-'+index+'" name="swatch-'+product.id+'-'+index+'">'

			var avilability = ''
			if (variant.inventory_quantity < 1) {
				var avilability = 'disabled';
			}

			var_label = '<label class="SizeSwatch '+avilability+'" for="swatch-'+variant.id+'-'+index+'">'+var_title+'</label>'

			$bundle_sizes.append('<li class="HorizontalList__Item">'+ var_input + var_label + '</p>')
		});

		$bundle_info.append($bundle_sizes)
		$bundle_info.append('<span class="ProductForm__Label">Colour</span>')


		product_key = product_title.split(' - ')[0]
		product_colour= product_title.split(' - ')[1].toLowerCase()

		$.each(JSON.parse(shop_data).results, function(i, item) {

			//console.log(product_key+'//'+item.key + item.colour);

			if (typeof product_key !== 'undefined' && product_key == item.key) {

				var current_product = ""
				if( item.colour == product_colour) {
					current_product = " is-active"
				}

				$bundle_colours.append('<button type="button" data-handle="'+item.handle+'" data-img="'+item.firstImage+'" class="ColorSwatch '+item.colour+current_product+'" style="background-color:'+item.colour+'; background-image:url('+item.swatch+')"></button>');
				//console.log('current: '+product_colour+' matched: '+ item.colour);
			}

		});

		$bundle_info.append($bundle_colours)

		$bundleObject.append($bundle_img, $bundle_info)
		$('.bundle-items').append($bundleObject)


	})
	.done(function() {
		//console.log( "second success" );
	})
	.fail(function() {
		console.log( "error" );
	})
	.always(function() {
	});
}

function loadBundles(shop_data) {

	$('.ProductForm').empty();
	$('.ProductForm').html('<div class="bundle-items"></div><div class="bundle-add"></div>');

	bundle_products = bundle_products.split(' / ')


	$.each(bundle_products, function(i, bundle_product) {

		//console.log(bundle_products)
		var index = i
		var found_product = false

		$.each(JSON.parse(shop_data).results, function(i, product) {
			//console.log(product)

			if ( found_product == false ) {
				product_key = product.key

				//console.log('bundle: '+bundle_product)
				//console.log('handle: '+product_key)

				if( typeof product_key != 'undefined' ) {
					if ( product_key.includes(bundle_product) ) {
						found_product = true

						//console.log('building:'+product.handle)

						buildBundleItem(index, bundle_product, product, shop_data)

					}
				}
			}
		});
	});

	$('.bundle-add').append('<button type="button" class="Button Button--primary Button--full">Add To Cart</button>');
}



function addProductsToCart(selected_variants){

	//console.log(bundle_items)
	let request = []
	Shopify.moveAlong = function() {
		if (selected_variants.length) {
			request = selected_variants.shift();

			dataObj = {
				quantity: request.qty,
				id: request.variant_id,
			};
			//console.log(dataObj)

			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: dataObj,
				success: function(res){
					console.log("added: " + dataObj);
					Shopify.moveAlong();
				},
				error: function(error){
					// if it's not last one Move Along else update the cart number with the current quantity
					if (Shopify.queue.length){
						Shopify.moveAlong()
					} else {
						console.log('error')
					}
				}
			});
		}
		else {
			// If the queue is empty, show confirmation popup
			console.log('completed - success')
			document.documentElement.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: request.variant_id,
					quantity: request.qty
				}
			}));
		}
	};
	Shopify.moveAlong();
};

$('.ProductForm').on('click', '.ProductItem__ColorSwatchList button', function() {
	swatch = $(this)
	swatch.closest('.ProductItem__ColorSwatchList').find('button').removeClass('is-active');
	swatch.addClass('is-active');
	index = swatch.closest('.bundle-object').data('index')

	$.getJSON('/products/' + swatch.data('handle'), function (product) {
		var product = product.product

		swatch.closest('.bundle-object').find('img').attr('src',swatch.data('img'))

		size_wrapper = swatch.closest('.bundle-object').find('.SizeSwatchList')

		size_wrapper.empty()

		$.each(product.variants, function(i, variant) {

			var_title = variant.title
			var_title = var_title.split(' / ')[0]

			var_input = '<input class="SizeSwatch__Radio" type="radio" data-id="'+variant.id+'" id="swatch-'+variant.id+'-'+index+'" name="swatch-'+product.id+'-'+index+'">'

			var avilability = ''
			if (variant.inventory_quantity < 1) {
				var avilability = 'disabled';
			}

			var_label = '<label class="SizeSwatch '+avilability+'" for="swatch-'+variant.id+'-'+index+'">'+var_title+'</label>'

			size_wrapper.append('<li class="HorizontalList__Item">'+ var_input + var_label + '</p>')
		});

	});
});


$('.ProductForm').on('click', '.bundle-add button', function() {
	selected_variants = []

	$.each( $('.bundle-items input[type="radio"]:checked') , function(i, bundle_product) {
		//products_to_add = products_to_add + ',' + $(this).data('id');

		selected_variant = {
			qty: 1,
			variant_id: $(this).data('id')
		}
		selected_variants.push(selected_variant)
	});

	addProductsToCart(selected_variants);

});

function build_bundle(bundle_products){
	selected_size = $('.SizeSwatchList input:checked').val()

	selected_variants = []
	if ( typeof selected_size == 'undefined' ) {
		alert('Please select a size')
	} else {
		$.each(bundle_products, function(i, product) {

			const product_qty = product.qty;
			console.log(product_qty)
			const selected_qty = $('input[name="quantity"]').val();
			console.log(selected_qty)
			console.log(product_qty * selected_qty)

			$.each(product.variants, function(i, variant) {

				if ( variant.option1 == selected_size ) {
					selected_variant = {
						qty: product_qty * selected_qty,
						variant_id: variant.id
					}
					selected_variants.push(selected_variant)
				}
			});
		});
	}

	addProductsToCart(selected_variants);
}

if ($('.show-bundles-loading').length > 0) {
	$('.ProductForm').empty();
	//$('.ProductMeta__Description, .Product__QuickNav').hide();
	$('.variant-sku').hide();

	$('.ProductForm').html('<div class="loading-message"><p>Loading bundle products...</p><hr/><div>');
}

if ($('body.template-product').length > 0) {
	var shop_data = null
	$.ajax({
		url:	"/collections/all?view=json",
		type:	'GET'
	})
	.done(function(data) {
		shop_data = data
	})
	.fail(function(data) {})
	.always(function(data) {

		if ( typeof bundle_products != 'undefined' && typeof bundle_type_1 != 'undefined' ) {
			if ( bundle_type_1 == true ) {
				$(loadBundles(shop_data));
			}
		} else {
			$(loadJSONProductColourSwatches);
		}
	});
}

$(document).on("click", "#add-fixed-bundle", function(event) {
	console.log('clicked');
	select_variant = $(this).closest('.ProductForm').find('input[type="radio"]:checked').val();

	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			quantity:1,
			id: select_variant
		},
		success: function(res){
			console.log("added: " + select_variant );
			document.documentElement.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: select_variant,
					quantity: 1
				}
			}));
			//update_collection_promos();
		},
		error: function(){
			// if it's not last one Move Along else update the cart number with the current quantity
			console.log('error')
		}
	});

});


$('.Product_fit-features').detach().appendTo('#Product-fit-features-placeholder')
$('.Product_fabric').detach().appendTo('#Product-fabric-placeholder')

$('#toggle-desc').click(function(){
  $(this).hide().css("opacity", "0");;
  $('#toggle-desc-close').css("display", "block");
  $('.collection-desc').removeClass('truncated')
  setTimeout(function(){
    $('#toggle-desc-close').css("opacity", "0.5");
  }, 300);
});
$('#toggle-desc-close').click(function(){
  $(this).hide().css("opacity", "0");;
  $('#toggle-desc').css("display", "block");
  $('.collection-desc').addClass('truncated')
  setTimeout(function(){
    $('#toggle-desc').css("opacity", "0.5");
  }, 800);
});

function add_gift(select_variant){
	console.log('triggered')
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			quantity:1,
			id: select_variant
		},
		success: function(res){
			console.log("added: " + select_variant );
			document.documentElement.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: select_variant,
					quantity: 1
				}
			}));
			//update_collection_promos();
		},
		error: function(){
			// if it's not last one Move Along else update the cart number with the current quantity
			console.log('error')
		}
	});
}

$('#sidebar-cart').on('click', '.add-gift', function() {

	const form = $(this).closest('.free-gift-form');

	const selectedOption = form.find('select').val();
	add_gift(selectedOption)
});

if (typeof auto_add_gift !== 'undefined' && auto_add_gift != '') {
	add_gift(auto_add_gift)
}

// Select the cart drawer contents element
const sidebarCart = document.getElementById('sidebar-cart');


/* Disabled shipping protection

// Use event delegation to attach a change event listener
sidebarCart.addEventListener('change', function(event) {
	// Check if the event target is the checkbox
	if (event.target.id === 'ship-protect-check') {
		if ( !event.target.checked) {
			// Checkbox is deselected, perform your desired action
			setCookie('shipping_protection', 'false', 1);
			const ship_protect_item = document.querySelector('[data-remove_handle="shipping-protection"]').click();
		} else {
			add_gift(event.target.value);
		}
	}
});

function check_ship_protect(recheck,event){
	const shipProtectCheck = document.getElementById('ship-protect-check');
	if (shipProtectCheck) {
		if ( getCookie("shipping_protection") != 'false' && !shipProtectCheck.checked ) {
			//console.log('lets add it!');
			shipProtectCheck.click();
		} else {
			//console.log('lets not?');
		}

		//Check if item doesn't require shipping
		if (event?.detail?.variant?.requires_shipping !== undefined) {
			const requires_shipping = event.detail.variant.requires_shipping;

			if (!requires_shipping) {
				if (shipProtectCheck?.checked) {
					// Protection is checked; verify if the cart requires shipping
					fetch('/cart.js', {
						method: 'GET',
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then(response => {
						if (!response.ok) {
							throw new Error(`HTTP error! Status: ${response.status}`);
						}
						return response.json();
					})
					.then(cart => {
						if (cart.requires_shipping === false) {
							// Cart doesn't require shipping; remove protection
							shipProtectCheck.click();
						}
					})
					.catch(error => {
						console.error('Error fetching cart:', error);
					});
				}
			}
		}

	} else if (recheck) {
		setTimeout(() => {
			check_ship_protect(true);
		}, "1000");
	}
}

document.addEventListener('product:added', function(event) {
	check_ship_protect(true,event);
});
check_ship_protect(false)*/

/* Code update - broken
const selectedCurrency = localStorage.getItem('currency') || 'AUD';
const selectedLocalization = getCookie('localization') || 'AU';

// Map currencies -> localization codes
const CURRENCY_TO_LOCALE = {
	AUD: 'AU',
	USD: 'US',
	CAD: 'CA',
	NZD: 'NZ',
	EUR: 'FR',
	GBP: 'GB',
};

const currencyLocale = CURRENCY_TO_LOCALE[selectedCurrency] || 'AU';

console.log(`${currencyLocale}/${selectedCurrency}/${selectedLocalization}`);

const localizationSelect = document.getElementById('localization-select');
if (localizationSelect)  {
	if (selectedLocalization !== currencyLocale) {
		const opt = localizationSelect.querySelector(`option[value="${currencyLocale}"]`);
		if (opt) {
			opt.selected = true;
			const button = localizationSelect.querySelector('.Button, button'); // exists per your note
			button.click();
			console.log('Localization changed to', currencyLocale);
		} else {
			console.warn('Desired locale option not found in custom dropdown:', currencyLocale);
		}
	}
} */

const
	selected_currency = localStorage.getItem("currency"),
	selected_localization = getCookie('localization'),
	localization_select = $('#localization-select'),
	currency_options = 'US CA GB FR NZ';
let currency_code = 'AU'
if ( selected_currency == 'USD') {
	currency_code = 'US'
} else if ( selected_currency == 'CAD') {
	currency_code = 'CA'
} else if ( selected_currency == 'NZD') {
	currency_code = 'NZ'
} else if ( selected_currency == 'EUR') {
	currency_code = 'FR'
} else if ( selected_currency == 'GBP') {
	currency_code = 'GB'
}

console.log( currency_code+'/'+selected_currency+'/'+selected_localization )
//check_currency_country()
change_localization = false

if ( selected_currency == 'AUD' && currency_options.indexOf(selected_localization) != -1) {
	//If AUD selected but localization is US, CA or GB
	change_localization = true
}

if ( selected_currency != 'AUD' && selected_localization != currency_code ) {
	//If non AUD selected and localization doesn't match
	change_localization = true
}

if ( change_localization ) {
	console.log(currency_code)
	localization_select.find('option[value="'+ currency_code +'"]').prop('selected', true)
	localization_select.find('.Button').click()
}

const swiper = new Swiper('.AnnouncementBar__Slider', {
	loop: true,
	autoplay: {
		delay: 6000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true
	},
	effect: "fade",
	navigation: {
		nextEl: '.AnnouncementBar__next',
		prevEl: '.AnnouncementBar__prev',
	}
});

//Close Popup Windows
$('.popup-wrapper .close-popup').click(function() {
	$(this).closest('.popup-wrapper').fadeOut();
});

$(".popup-wrapper").click(function(e) {
	if(e.target !== e.currentTarget) return;
	e.preventDefault();
	$(this).fadeOut();
});

$('#product-popup-trigger').click(function(){
	$('#product-popup-content').show();
});

$('#product-popup-2-trigger').click(function(){
	$('#product-popup-2-content').show();
});

$('#about-popup-trigger').click(function(){
	$('#about-popup-content').show();
});

$('.view-extra-features').click(function(){
	if ( $(this).text() == 'Hide info') {
		$(this).text('View more info');
	} else {
		$(this).text('Hide info');
	}

	$('.secondary-features').toggleClass('open');
});


$('.features-carousel').flickity({
	// options
	cellAlign: 'left',
	contain: true,
	prevNextButtons: false,
	groupCells: true
});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

/* For Markets
let
exchange_data = getCookie("exchange_data"),
exchange_rate = 1;

exchange_data = exchange_data.split(':');

if ( exchange_data != '' ) {
	exchange_currency = exchange_data[0];
	exchange_rate = exchange_data[1];
}


if ( cart_currency != 'AUD' && cart_currency != 'USD'  ) {
	if ( exchange_data == '' || exchange_currency != cart_currency ) {

		//console.log('lets search:'+cart_currency)
		const local_price = parseInt(document.getElementById('exchange-rate').innerHTML);

		fetch('https://mrsimple.com.au/collections?country=AU')
		.then(response => response.text())
		.then(html => {
			//console.log( html )
			var parser = new DOMParser();
			var pageHTML = parser.parseFromString(html, 'text/html');

			const au_price = parseInt(pageHTML.getElementById('exchange-rate').innerHTML);

			//console.log( 'local:'+ local_price + ' /  au_price:'+ au_price );

			exchange_rate = local_price / au_price

			setCookie('exchange_data', cart_currency+':'+exchange_rate), 0.1;

			//console.log( 'exchange_data:'+ exchange_rate);
			console.log( 'localization_cookie:'+localization_cookie)

			fetch('https://mrsimple.com.au/collections?country='+localization_cookie)
			.then(response => response.text())
			.then(html => {
				//All good cookie reset to NZ
				update_cart_gwp();
			})
			.catch(e => {
				console.error(e);
			});
		})
		.catch(e => {
			console.error(e);
		});
	}
} else {
	//console.log('have data')
	//console.log( exchange_data )
}
*/
update_cart_gwp();


/*
console.log('url:'+window.location.href+'?country=AU')

fetch(window.location.href+'?country=AU')
.then(response => response.text())
.then(html => {
	//console.log( html )
	var parser = new DOMParser();
	var pageHTML = parser.parseFromString(html, 'text/html');

	const raw_price = pageHTML.getElementById('raw-price').innerHTML;

	console.log( 'price:'+ raw_price)


})
.catch(e => {
	console.error(e);
});*/

/*
// Function to convert kg to lbs

//Built for Oct 2024, never used

function kgToLbs(kg) {
	//round to 2 decimals
	//return (kg * 2.20462).toFixed(2); // 1 kg = 2.20462 lbs

	//round to nearest whole numbers
	return Math.round(kg * 2.20462);
}

function cmToFeetInches(cm) {
	let totalInches = cm * 0.393701; // Convert cm to inches
	if ( cm > 140 ) {
		let feet = Math.floor(totalInches / 12); // Calculate the number of feet
		let inches = Math.round(totalInches % 12); // Get the remaining inches

		return `${feet}ft ${inches}in`;
	} else {
		let inches = totalInches.toFixed(1);
		return `${inches}"`;
	}
}

const size_tds = document.querySelectorAll('.Modal td, .Modal th');
// Function to find and convert kg strings in table
function convertKgToLbsInTable() {
		console.log('converting')

		// Regular expression to match strings like '40-50kg'
		let kgRegex = /(\d+)?-?(\d+)?kg/;
		let cmRegex = /(\d+)?-?(\d+)?cm/;
		let numberRegex = /^\d+(\.\d+)?$/;

		// Loop over all the <td> elements
		size_tds.forEach(function(td) {
				let text = td.textContent.trim();
				//console.log(text);
				// Check if the text matches the 'kg' format

				let matchKg = text.match(kgRegex);
				if (matchKg) {
					let min = parseFloat(matchKg[1]);
					let max = parseFloat(matchKg[2]);

					min = kgToLbs(min);
					max = kgToLbs(max);
					//td.textContent = `${min} - ${max}lbs`;
					td.setAttribute('data-cm', text);

					if (max != 'NaN' && !isNaN(max)) {
						td.setAttribute('data-inch', `${min} - ${max}lbs`);
					} else {
						td.setAttribute('data-inch', `${min}lbs`);
					}
				}

				let matchCm = text.match(cmRegex);
				if (matchCm) {
					let min = parseFloat(matchCm[1]);
					let max = parseFloat(matchCm[2]);

					min = cmToFeetInches(min);
					max = cmToFeetInches(max);
					//td.textContent = `${min} - ${max}`;
					td.setAttribute('data-cm', text);

					console.log( min );
					console.log( max );
					if (max != 'NaN"') {
						console.log('not nan;')
						td.setAttribute('data-inch', `${min} - ${max}`);
					} else {
						console.log('is nan;')
						td.setAttribute('data-inch', min);
					}
				}

				let matchNumber = text.match(numberRegex);
				if (matchNumber) {
					let number = parseFloat(matchNumber);

					number = cmToFeetInches(number);
					//td.textContent = `${min} - ${max}`;
					td.setAttribute('data-cm', text);

					console.log( number );
					td.setAttribute('data-inch', number);
				}
		});
}

// Run the conversion function
convertKgToLbsInTable();
*/

/*
Size convertor developed in Oct 2024 but never used
// Event listener for radio button changes
const switch_radios = document.querySelectorAll('input[name="switch-units"]');
console.log( switch_radios );
switch_radios.forEach(function(radio) {
	radio.addEventListener('change', function() {
		const selectedUnit = document.querySelector('input[name="switch-units"]:checked').value; // 'cm' or 'inch'
		//console.log('selectedUnit :'+selectedUnit)
		size_tds.forEach(function(td) {
			const newValue = td.getAttribute(`data-${selectedUnit}`);

			//console.log( newValue );
			if ( newValue ){
				td.textContent = newValue;
			}
		});
	});
});*/

document.querySelectorAll('.size-chart-units a').forEach(link => {
		link.addEventListener('click', function(event) {
				event.preventDefault(); // Prevent default link behavior if it's a link

				// Get the target unit from the clicked link's data-target attribute
				const targetUnit = this.getAttribute('data-target');

				// Find the closest .size-chart parent element
				const sizeChart = this.closest('.size-chart');

				if (sizeChart) {
						// Remove .active class from all tables within the .size-chart parent
						sizeChart.querySelectorAll('table').forEach(table => {
								table.classList.remove('active');
						});

						sizeChart.querySelectorAll('.size-chart-units a').forEach(table => {
								table.classList.remove('active');
						});
						this.classList.add('active');

						// Find the table with matching data-unit attribute and add the .active class
						const targetTable = sizeChart.querySelector(`table[data-unit="${targetUnit}"]`);
						if (targetTable) {
								targetTable.classList.add('active');
						}
				}
		});
});

(function () {
	if (window.__mrs_bundle_opts_init__) return;
	window.__mrs_bundle_opts_init__ = true;

	const atc_price = document.querySelector('.atc-price');
	if (!atc_price) return;

	const og_price = atc_price.innerHTML;

	// Delegate changes within any .BundleATC container
	document.addEventListener('change', function (e) {
		var checkbox = e.target.closest && e.target.closest('.BundleATC__checkbox');
		if (!checkbox) return;

		var label = checkbox.closest('.BundleATC__option');
		var group = checkbox.closest('.BundleATC');
		if (!group || !label) return;

		// Enforce "radio-like" behavior:
		// If this box is being checked, uncheck all others.
		// If it's being unchecked, leave all unchecked.
		if (checkbox.checked) {
			group.querySelectorAll('.BundleATC__checkbox').forEach(function (cb) {
				if (cb !== checkbox) {
					cb.checked = false;
					cb.closest('.BundleATC__option').classList.remove('is-selected');
				}
			});
			label.classList.add('is-selected');

			atc_price.innerHTML = label.querySelector('.each-price').innerHTML;
		} else {
			label.classList.remove('is-selected');
		}

		// Find the form and its quantity input (already exists per your note)
		var form = group.closest('form');
		if (!form) return;
		var qtyInput = form.querySelector('input[name="quantity"]');
		if (!qtyInput) return;

		// Determine selected qty or default to 1 when none selected
		var selected = group.querySelector('.BundleATC__checkbox:checked');
		var qty = selected ? parseInt(selected.value, 10) : 1;
		if (!qty || qty < 1) {
			qty = 1;
		}

		qtyInput.value = qty;

		if (qty == 1) {
			atc_price.innerHTML = og_price;
		}
	}, false);

	// On load, ensure UI + quantity reflect current selection (or default to 1)
	/* Use it was want to preselect best deal
	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.BundleATC').forEach(function (group) {
			var form = group.closest('form');
			var qtyInput = form && form.querySelector('input[name="quantity"]');
			if (!qtyInput) return;

			var selected = group.querySelector('.BundleATC__checkbox:checked');
			if (selected) {
				// Mark selected for styling and sync qty
				selected.closest('.BundleATC__option').classList.add('is-selected');
				qtyInput.value = parseInt(selected.value, 10) || 1;
			} else {
				// No selection → default qty to 1
				qtyInput.value = 1;
			}
		});
	});*/
})();


/* === COUNTDOWNS ===*/


(function () {
	const LocalzoneOffsetMs = new Date().getTimezoneOffset() * 60 * 1000;
	const AUoffsetMinutes = 10 * 60; // +10:00
	const AUzoneOffsetMs = AUoffsetMinutes * 60 * 1000;
	const DEFAULT_TIME_SHIFT_MS = AUzoneOffsetMs + LocalzoneOffsetMs;

	const pad2 = (n) => (n < 10 ? "0" + n : String(n));
	const plural = (n, s, p) => (n === 1 ? s : p);

	function computeParts(distanceMs) {
		const days = Math.floor(distanceMs / 86400000);
		const hours = Math.floor((distanceMs % 86400000) / 3600000);
		const minutes = Math.floor((distanceMs % 3600000) / 60000);
		const seconds = Math.floor((distanceMs % 60000) / 1000);
		return { days, hours, minutes, seconds };
	}

	const renderers = {
		inlineVerbose: ({ d, h, m, s }) => {
			const parts = [];
			if (d > 0) parts.push(`<span>${d}</span> ${plural(d, "day", "days")}`);
			if (h > 0 || d > 0) parts.push(`<span>${h}</span> ${plural(h, "hour", "hours")}`);
			if (m > 0 || h > 0 || d > 0) parts.push(`<span>${m}</span>m`);
			parts.push(`<span>${s}</span>s`);
			return `<strong>${parts.join(" ")}</strong>`;
		},
		colon: ({ d, h, m, s }) => {
			const dd = d > 0 ? `<span class="days">${pad2(d)}</span><span>:</span>` : "";
			return `${dd}<span class="hours">${pad2(h)}</span><span>:</span><span class="mins">${pad2(m)}</span><span>:</span><span class="secs">${pad2(s)}</span>`;
		},
		announcement: ({ d, h, m, s }) => {
			if (d > 0) return `<span class="time-${d}">${d} ${plural(d,"Day","Days")}</span><span>${h}H</span><span>${m} M</span><span>${s} S</span>`;
			if (h > 0) return `<span>${h} ${plural(h,"Hour","Hours")}</span><span>${m} M</span><span>${s} S</span>`;
			return `<span>${m} ${plural(m,"Min","Mins")}</span><span>${s} S</span>`;
		}
	};

	function startCountdown({ el, end, renderer = "inlineVerbose", timezoneShiftMs = DEFAULT_TIME_SHIFT_MS, tickMs = 1000, expiredText = "" }) {
		const target = el;
		const endMs = (end instanceof Date && end.getTime()) || (typeof end === "number" && end) || new Date(end).getTime();
		if (!target || !endMs || isNaN(endMs)) return;

		const renderFn = typeof renderer === "function" ? renderer : renderers[renderer] || renderers.inlineVerbose;
		let intervalId = null;

		const tick = () => {
			if (!document.body.contains(target)) { clearInterval(intervalId); return; }
			const distance = endMs - (Date.now() + timezoneShiftMs);
			if (distance <= 0) { clearInterval(intervalId); target.innerHTML = expiredText; return; }
			const { days:d, hours:h, minutes:m, seconds:s } = computeParts(distance);
			target.classList.remove("loading");
			target.innerHTML = renderFn({ d, h, m, s, distance });
		};

		tick();
		intervalId = setInterval(tick, tickMs);
	}

	function parseRenderer(node) {
		const v = node.getAttribute("data-variant") || "inlineVerbose";
		// You can extend with custom functions by attaching to window.CountdownRenderers
		if (window.CountdownRenderers && typeof window.CountdownRenderers[v] === "function") return window.CountdownRenderers[v];
		return v;
	}

	function initFromDataAttributes(root = document) {
		root.querySelectorAll("[data-countdown]:not([data-countdown-initialized])").forEach((node) => {
			const endRaw = node.getAttribute("data-end");
			const expiredText = node.getAttribute("data-expired") || "";
			const tzShift = node.getAttribute("data-tz-shift-ms");
			const tickMs = Number(node.getAttribute("data-tick-ms") || 1000);
			const renderer = parseRenderer(node);

			node.setAttribute("data-countdown-initialized", "true");
			startCountdown({
				el: node,
				end: endRaw,
				renderer,
				expiredText,
				tickMs,
				timezoneShiftMs: tzShift === null ? DEFAULT_TIME_SHIFT_MS : Number(tzShift)
			});
		});
	}

	// Expose the two things you asked for
	window.Countdown = {
		initFromDataAttributes
	};

	// Auto-init on load
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => initFromDataAttributes());
	} else {
		initFromDataAttributes();
	}

	// Re-init on dynamic changes (theme editor, AJAX sections, etc.)
	const mo = new MutationObserver((mutations) => {
		for (const m of mutations) {
			m.addedNodes && m.addedNodes.forEach((n) => {
				if (n.nodeType === 1) initFromDataAttributes(n);
			});
		}
	});
	mo.observe(document.documentElement, { childList: true, subtree: true });

	// Shopify section hooks (if present)
	document.addEventListener("shopify:section:load", (e) => initFromDataAttributes(e.target));
	document.addEventListener("shopify:section:select", (e) => initFromDataAttributes(e.target));
})();

